import { render, staticRenderFns } from "./Futbol.vue?vue&type=template&id=40ab8d2a&scoped=true"
import script from "./Futbol.vue?vue&type=script&lang=js"
export * from "./Futbol.vue?vue&type=script&lang=js"
import style0 from "./Futbol.vue?vue&type=style&index=0&id=40ab8d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ab8d2a",
  null
  
)

export default component.exports